import { render, staticRenderFns } from "./subnav.vue?vue&type=template&id=d55c8bae&scoped=true"
import script from "./subnav.vue?vue&type=script&lang=js"
export * from "./subnav.vue?vue&type=script&lang=js"
import style0 from "./subnav.vue?vue&type=style&index=0&id=d55c8bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55c8bae",
  null
  
)

export default component.exports